<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-laravel
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>
  <sidenav :custom_class="this.$store.state.mcolor" :class="[
    this.$store.state.isTransparent,
    this.$store.state.isRTL ? 'fixed-end' : 'fixed-start'
  ]" v-if="this.$store.state.showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <!-- nav -->
    <navbar :class="[navClasses]" :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      " :minNav="navbarMinimize" v-if="this.$store.state.showNavbar" />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />


    <configurator ref="configurator" :toggle="toggleConfigurator" :class="[
      this.$store.state.showConfig ? 'show' : '',
      this.$store.state.hideConfigButton ? 'd-none' : '',
      isCatalogRoute ? 'd-none' : ''
    ]" />

    <!-- Modulo Categoria: Listado con paginación -->
    <div class="modal fade" id="ModalCategory" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Categorías</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <!-- Barra superior: búsqueda + botón agregar -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="input-group" style="max-width: 300px;">
                <input type="text" v-model="categorySearch" class="form-control"
                  placeholder="Buscar..." @keyup.enter="searchCategories">
                <button class="btn btn-outline-primary" @click="searchCategories">
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <button type="button" class="btn btn-primary" @click="openCategoryForm">
                <i class="fa fa-plus"></i> Agregar
              </button>
            </div>

            <!-- Tabla de categorías -->
            <div class="table-responsive">
              <table class="table table-hover align-middle">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 120px;">Código</th>
                    <th>Nombre</th>
                    <th>Categoría padre</th>
                    <th class="text-end">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in categoryPage.data" :key="value.id">
                    <td>{{ value.code || '-' }}</td>
                    <td>{{ value.name }}</td>
                    <td>{{ parentName(value.parent_id) }}</td>
                    <td class="text-end">
                      <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editCategory(value)">
                        <i class="fa fa-edit"></i>
                      </a>
                      <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                        @click="deleteCategory(value.id)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="categoryPage.data && categoryPage.data.length === 0">
                    <td colspan="4" class="text-center text-muted py-3">No hay categorías registradas.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div class="d-flex justify-content-between align-items-center mt-3">
              <span class="text-xs text-muted">
                Mostrando {{ categoryPage.from || 0 }}-{{ categoryPage.to || 0 }} de {{ categoryPage.total || 0 }}
              </span>
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: !categoryPage.prev_page_url }">
                    <a class="page-link cursor-pointer" @click="changeCategoryPage(categoryPage.current_page - 1)">&laquo;</a>
                  </li>
                  <li class="page-item" v-for="link in categoryPageLinks" :key="link.label"
                    :class="{ active: link.active, disabled: link.url === null }">
                    <a class="page-link cursor-pointer" v-html="link.label" @click="goToCategoryPage(link)"></a>
                  </li>
                  <li class="page-item" :class="{ disabled: !categoryPage.next_page_url }">
                    <a class="page-link cursor-pointer" @click="changeCategoryPage(categoryPage.current_page + 1)">&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalCategory">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Categoria: Formulario (alta/edición) -->
    <div class="modal fade" id="ModalCategoryForm" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEditingCategory ? 'Editar Categoria' : 'Agregar Categoria' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitCategory">
              <div class="mb-3">
                <label class="form-label">Código</label>
                <input type="text" v-model="category.code" class="form-control" placeholder="Código">
              </div>
              <div class="mb-3">
                <label class="form-label">Nombre <span class="text-danger">*</span></label>
                <input type="text" v-model="category.name" class="form-control" placeholder="Categoria" required>
              </div>
              <div class="mb-3">
                <label class="form-label">Categoría padre</label>
                <select v-model="category.parent_id" class="form-select">
                  <option value="" selected>Seleccionar</option>
                  <option v-for="process in parents" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Descripción</label>
                <textarea v-model="category.description" class="form-control" rows="2"
                  placeholder="Descripción (opcional)"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelEditCategory">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="submitCategory">
              <i class="fa fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Coleccion: Listado con paginación -->
    <div class="modal fade" id="ModalCollection" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Colecciones</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <!-- Barra superior: búsqueda + botón agregar -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="input-group" style="max-width: 300px;">
                <input type="text" v-model="collectionSearch" class="form-control"
                  placeholder="Buscar..." @keyup.enter="searchCollections">
                <button class="btn btn-outline-primary" @click="searchCollections">
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <button type="button" class="btn btn-primary" @click="openCollectionForm">
                <i class="fa fa-plus"></i> Agregar
              </button>
            </div>

            <!-- Tabla de colecciones -->
            <div class="table-responsive">
              <table class="table table-hover align-middle">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 120px;">Código</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th class="text-end">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in collectionPage.data" :key="value.id">
                    <td>{{ value.code || '-' }}</td>
                    <td>{{ value.name }}</td>
                    <td>{{ value.description || '-' }}</td>
                    <td class="text-end">
                      <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editCollection(value)">
                        <i class="fa fa-edit"></i>
                      </a>
                      <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                        @click="deleteCollection(value.id)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="collectionPage.data && collectionPage.data.length === 0">
                    <td colspan="4" class="text-center text-muted py-3">No hay colecciones registradas.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div class="d-flex justify-content-between align-items-center mt-3">
              <span class="text-xs text-muted">
                Mostrando {{ collectionPage.from || 0 }}-{{ collectionPage.to || 0 }} de {{ collectionPage.total || 0 }}
              </span>
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: !collectionPage.prev_page_url }">
                    <a class="page-link cursor-pointer" @click="changeCollectionPage(collectionPage.current_page - 1)">&laquo;</a>
                  </li>
                  <li class="page-item" v-for="link in collectionPage.links" :key="link.label"
                    :class="{ active: link.active, disabled: link.url === null }">
                    <a class="page-link cursor-pointer" v-html="link.label" @click="goToCollectionPage(link)"></a>
                  </li>
                  <li class="page-item" :class="{ disabled: !collectionPage.next_page_url }">
                    <a class="page-link cursor-pointer" @click="changeCollectionPage(collectionPage.current_page + 1)">&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalCollection">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Coleccion: Formulario (alta/edición) -->
    <div class="modal fade" id="ModalCollectionForm" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEditingCollection ? 'Editar Colección' : 'Agregar Colección' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitCollection">
              <div class="mb-3">
                <label class="form-label">Código</label>
                <input type="text" v-model="collection.code" class="form-control" placeholder="Código">
              </div>
              <div class="mb-3">
                <label class="form-label">Nombre <span class="text-danger">*</span></label>
                <input type="text" v-model="collection.name" class="form-control" placeholder="Colección" required>
              </div>
              <div class="mb-3">
                <label class="form-label">Descripción</label>
                <textarea v-model="collection.description" class="form-control" rows="2"
                  placeholder="Descripción (opcional)"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelEditCollection">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="submitCollection">
              <i class="fa fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Color -->
    <div class="modal fade" id="ModalColors" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Color</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-4">
                  <input type="text" v-model="color.name" class="form-control" placeholder="Color" />
                </div>
                <div class="col-4">
                  <input type="text" v-model="color.ref" class="form-control" placeholder="Referencia" />
                </div>

                <div class="col-4">
                  <!-- Si NO estás editando, muestra el botón "+" -->
                  <button v-if="!isEditingColor" type="button" class="btn btn-primary" @click="submitColor">
                    +
                  </button>

                  <!-- Si SÍ estás editando, muestra boton de 'editar' y 'cancelar' -->
                  <div v-else>
                    <button type="button" class="btn btn-warning"
                      @click="submitColor">
                      <i class="fa fa-edit fa-xs" ></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 5px;" @click="cancelEditColor">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de colores -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in colors"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.name }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editColor(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteColors(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalColors">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modulo Tallas -->
    <div class="modal fade" id="ModalTallas" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Talla</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="sizeList.size" class="form-control" placeholder="Talla">
                </div>
                <!-- Botón: muestra "+" si NO se está editando; si se edita, muestra editar y cancelar -->
                <div class="col-4">
                  <button v-if="!isEditingTalla" type="button" class="btn btn-primary" @click="submitTalla">
                    +
                  </button>
                  <div v-else>
                    <button type="button" class="btn btn-warning" 
                      @click="submitTalla">
                      <i class="fa fa-edit fa-xs" ></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 5px;" @click="cancelEditTalla">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de tallas -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in tallas"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.size }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editTalla(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteTalla(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalTallas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modulo Oficio -->
    <div class="modal fade" id="ModalOficios" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Oficio</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="oficio.name" class="form-control" placeholder="Oficio">
                </div>

                <!-- Botón + si NO estás editando; Si SÍ estás editando, muestra Editar y Cancelar -->
                <div class="col-4">
                  <button v-if="!isEditingOficio" type="button" class="btn btn-primary" @click="submitOficio">+</button>
                  <div v-else>
                    <button type="button" class="btn btn-warning" 
                      @click="submitOficio">
                      <i class="fa fa-edit fa-xs"></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style=" margin-left: 5px;" @click="cancelEditOficio">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de oficios -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in oficios"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.name }}</span>
              <span>
                <a @click="editOficio(value)" >
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteOficios(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalOficios">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modulo Bodega -->
    <div class="modal fade" id="ModalBodegas" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Bodega</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="bodega.name" class="form-control" placeholder="Bodega">
                </div>
                <div class="col-4">
                  <!-- Si NO estás editando, muestra el botón "añadir" -->
                  <button v-if="!isEditing" type="button" class="btn btn-primary" @click="submitBodega">+</button>

                  <!-- Si estás editando, muestra botón "editar" y botón "X" (cancelar) -->
                  <div v-else>
                    <button type="button" class="btn btn-warning" 
                      @click="submitBodega">
                      <i class="fa fa-edit fa-xs" ></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 15px;" @click="cancelEditBodega">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de bodegas -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in bodegas"
              :key="value.id" style="padding: 3px 15px;margin: 2px;">
              <span>{{ value.name }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editBodega(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteBodegas(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalBodegas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import Swal from 'sweetalert2';
import * as bootstrap from 'bootstrap';


export default {
  name: "App",
  data() {
    return {
      category: {
        id: 0,
        code: '',
        name: '',
        description: '',
        parent_id: ''
      },
      categorySearch: '',
      categoryPage: {
        data: [],
        current_page: 1,
        from: 0,
        to: 0,
        total: 0,
        per_page: 10,
        last_page: 1,
        prev_page_url: null,
        next_page_url: null,
        links: [],
      },
      categoryPerPage: 10,
      collection: {
        id: 0,
        code: '',
        name: '',
        description: '',
      },
      collectionSearch: '',
      collectionPage: {
        data: [],
        current_page: 1,
        from: 0,
        to: 0,
        total: 0,
        per_page: 10,
        last_page: 1,
        prev_page_url: null,
        next_page_url: null,
        links: [],
      },
      collectionPerPage: 10,
      color: {
        id: 0,
        name: '',
        ref: ''
      },
      oficio: {
        id: 0,
        name: '',
        description: '',
        status: 1,
      },
      bodega: {
        id: 0,
        name: '',
        description: '',
        status: 1,
      },
      sizeList: {
        id: 0,
        size: ''
      },
      categories: [],
      collections: [],
      parents: [],
      colors: [],
      oficios: [],
      bodegas: [],
      tallas: [],
    }
  },
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter
  },
  watch: {
    '$route.path'(path) {
      const isCatalog = path.startsWith('/catalogo/');
      this.$store.state.showSidenav = !isCatalog;
      this.$store.state.showNavbar = !isCatalog;
      this.$store.state.showFooter = !isCatalog;
    },
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    closeModalCategory() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalCategory(); // Llama al método para cerrar el modal
      }
    },
    openCategoryForm() {
      this.isEditingCategory = false;
      this.resetCategoryForm();
      const modal = new bootstrap.Modal(document.getElementById('ModalCategoryForm'));
      modal.show();
    },
    resetCategoryForm() {
      this.category = {
        id: 0,
        code: '',
        name: '',
        description: '',
        parent_id: '',
      };
    },
    async submitCategory() {
      try {
        // Dispara la acción de Vuex para guardar la categoría
        const response = await this.$store.dispatch("categories/save", this.category);

        if (response && response.status >= 200 && response.status < 300) {
          // Cierra el modal del formulario
          const formModalEl = document.getElementById('ModalCategoryForm');
          const formModal = bootstrap.Modal.getInstance(formModalEl);
          if (formModal) formModal.hide();

          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Limpia el formulario y refresca la tabla paginada
          this.resetCategoryForm();
          this.isEditingCategory = false;
          await this.getCategoriesPaginated(this.categoryPage.current_page);
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editCategory(value) {
      this.isEditingCategory = true;
      this.category = {
        id: value.id,
        code: value.code || '',
        name: value.name,
        description: value.description || '',
        parent_id: value.parent_id || '',
      };
      const modal = new bootstrap.Modal(document.getElementById('ModalCategoryForm'));
      modal.show();
    },
    async cancelEditCategory() {
      this.isEditingCategory = false;
      this.resetCategoryForm();
      const formModalEl = document.getElementById('ModalCategoryForm');
      const formModal = bootstrap.Modal.getInstance(formModalEl);
      if (formModal) formModal.hide();
    },
    async getCategories() {
      const response = await this.$store.dispatch("categories/getCategories");
      this.categories = response.data;
      this.categories.sort((a, b) => a.fullname.localeCompare(b.fullname));
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async getCategoriesPaginated(page = 1) {
      try {
        const response = await this.$store.dispatch("categories/getPaginated", {
          page,
          per_page: this.categoryPerPage,
          search: this.categorySearch,
        });
        this.categoryPage = response.data;
      } catch (error) {
        console.error("Error al obtener categorías paginadas:", error);
      }
    },
    async searchCategories() {
      await this.getCategoriesPaginated(1);
    },
    async changeCategoryPage(page) {
      if (page < 1 || page > this.categoryPage.last_page) return;
      await this.getCategoriesPaginated(page);
    },
    async goToCategoryPage(link) {
      if (!link.url || link.active) return;
      // link.label puede venir como "&laquo;" o número; usamos la URL para extraer la página
      const url = new URL(link.url, window.location.origin);
      const page = parseInt(url.searchParams.get('page') || '1', 10);
      await this.getCategoriesPaginated(page);
    },
    parentName(parentId) {
      if (!parentId) return '';
      const parent = this.categories.find(c => c.id === parentId);
      return parent ? parent.name : '';
    },
    async deleteCategory(id) {
      const response = await this.$store.dispatch("categories/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        await this.getCategoriesPaginated(this.categoryPage.current_page);
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },
    closeModalCollection() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalCollection();
      }
    },
    openCollectionForm() {
      this.isEditingCollection = false;
      this.resetCollectionForm();
      const modal = new bootstrap.Modal(document.getElementById('ModalCollectionForm'));
      modal.show();
    },
    resetCollectionForm() {
      this.collection = {
        id: 0,
        code: '',
        name: '',
        description: '',
      };
    },
    async submitCollection() {
      try {
        const response = await this.$store.dispatch("collections/save", this.collection);

        if (response && response.status >= 200 && response.status < 300) {
          const formModalEl = document.getElementById('ModalCollectionForm');
          const formModal = bootstrap.Modal.getInstance(formModalEl);
          if (formModal) formModal.hide();

          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          this.resetCollectionForm();
          this.isEditingCollection = false;
          await this.getCollectionsPaginated(this.collectionPage.current_page);
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editCollection(value) {
      this.isEditingCollection = true;
      this.collection = {
        id: value.id,
        code: value.code || '',
        name: value.name,
        description: value.description || '',
      };
      const modal = new bootstrap.Modal(document.getElementById('ModalCollectionForm'));
      modal.show();
    },
    async cancelEditCollection() {
      this.isEditingCollection = false;
      this.resetCollectionForm();
      const formModalEl = document.getElementById('ModalCollectionForm');
      const formModal = bootstrap.Modal.getInstance(formModalEl);
      if (formModal) formModal.hide();
    },
    async getCollections() {
      const response = await this.$store.dispatch("collections/getCollections");
      this.collections = response.data;
    },
    async getCollectionsPaginated(page = 1) {
      try {
        const response = await this.$store.dispatch("collections/getPaginated", {
          page,
          per_page: this.collectionPerPage,
          search: this.collectionSearch,
        });
        this.collectionPage = response.data;
      } catch (error) {
        console.error("Error al obtener colecciones paginadas:", error);
      }
    },
    async searchCollections() {
      await this.getCollectionsPaginated(1);
    },
    async changeCollectionPage(page) {
      if (page < 1 || page > this.collectionPage.last_page) return;
      await this.getCollectionsPaginated(page);
    },
    async goToCollectionPage(link) {
      if (!link.url || link.active) return;
      const url = new URL(link.url, window.location.origin);
      const page = parseInt(url.searchParams.get('page') || '1', 10);
      await this.getCollectionsPaginated(page);
    },
    async deleteCollection(id) {
      const response = await this.$store.dispatch("collections/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        await this.getCollectionsPaginated(this.collectionPage.current_page);
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },
    async submitColor() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("colors/save", this.color);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getColors();
              this.color.id = 0;
              this.color.name = '';
              this.color.ref = '';
              this.isEditingColor = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editColor(value) {
      this.isEditingColor = true;
      this.color = {
        id: value.id,
        name: value.name,
        ref: value.ref,
      };
    },
    async cancelEditColor() {
      this.isEditingColor = false;
      this.color.id = 0;
      this.color.name = '';
      this.color.ref = '';
    },
    async getColors() {
      const response = await this.$store.dispatch("colors/getColors");
      this.colors = response.data;
    },
    async deleteColors(id) {
      const response = await this.$store.dispatch("colors/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getColors();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },
    closeModalColors() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalColors(); // Llama al método para cerrar el modal
      }
    },
    async submitOficio() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("oficios/save", this.oficio);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getOficios();
              this.oficio.id = 0;
              this.oficio.name = '';
              this.oficio.description = '';
              this.oficio.status = 1;
              this.isEditingOficio = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editOficio(value) {
      this.isEditingOficio = true;
      this.oficio = {
        id: value.id,
        name: value.name,
        description: value.description,
        status: value.status,
      };

    },
    async getOficios() {
      const response = await this.$store.dispatch("oficios/getOficios");
      this.oficios = response.data;
    },
    async deleteOficios(id) {
      const response = await this.$store.dispatch("oficios/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getOficios();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalOficios() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalOficios(); // Llama al método para cerrar el modal
      }
    },
    cancelEditOficio() {
      this.isEditingOficio = false;
      this.oficio = { id: 0, name: '', description: '', status: 1 };
    },
    async submitBodega() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("bodegas/save", this.bodega);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getBodegas();
              this.bodega.id = 0;
              this.bodega.name = '';
              this.bodega.description = '';
              this.bodega.status = 1;
              this.isEditing = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editBodega(value) {
      this.isEditing = true;
      this.bodega = {
        id: value.id,
        name: value.name,
        description: value.description,
        status: value.status,
      };
    },
    async cancelEditBodega() {
      this.isEditing = false;
      this.bodega.id = 0;
      this.bodega.name = '';
      this.bodega.description = '';
      this.bodega.status = 1;
    },
    async getBodegas() {
      const response = await this.$store.dispatch("bodegas/getAll");
      this.bodegas = response;
    },
    async deleteBodegas(id) {
      const response = await this.$store.dispatch("bodegas/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getBodegas();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalBodegas() {
      // Obtén el elemento del modal
      const modalElement = document.getElementById('ModalBodegas');
      // Obtén la instancia existente o crea una nueva
      let modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (!modalInstance) {
        modalInstance = new bootstrap.Modal(modalElement);
      }
      // Cierra el modal
      modalInstance.hide();

      // Reinicia el formulario y el estado de edición
      this.bodega.id = 0;
      this.bodega.name = '';
      this.bodega.description = '';
      this.bodega.status = 1;
      this.isEditing = false;
    },

    async submitTalla() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("tallas/save", this.sizeList);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getTallas();
              this.sizeList.id = 0;
              this.sizeList.size = '';
              this.isEditingTalla = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editTalla(value) {
      this.isEditingTalla = true;
      this.sizeList = {
        id: value.id,
        size: value.size,
      };
    },
    async cancelEditTalla() {
      this.isEditingTalla = false;
      this.sizeList.id = 0;
      this.sizeList.size = '';
    },
    async getTallas() {
      const response = await this.$store.dispatch("tallas/getAll");
      this.tallas = response;
    },
    async deleteTalla(id) {
      const response = await this.$store.dispatch("tallas/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getTallas();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalTallas() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalTallas(); // Llama al método para cerrar el modal
      }
    },
  },
  computed: {
    isCatalogRoute() {
      return this.$route.path.startsWith('/catalogo/');
    },
    categoryPageLinks() {
      // Filtra los links "..." del paginador de Laravel para mostrarlos como disabled
      return (this.categoryPage.links || []).map(link => {
        // Limpia las flechas &laquo; &raquo; para mostrarlas como texto simple
        return link;
      });
    },
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.isAbsolute
      };
    }
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
  mounted() {

    let user = JSON.parse(localStorage.getItem('user'));

    // Verificar si el usuario existe
    if (user) {
      this.getCategories();
      this.getCategoriesPaginated(1);
      this.getCollections();
      this.getCollectionsPaginated(1);
      this.getColors();
      this.getOficios();
      this.getBodegas();
      this.getTallas();

      // Refrescar la tabla paginada cada vez que se abra el modal de categorías
      const categoryModalEl = document.getElementById('ModalCategory');
      if (categoryModalEl) {
        categoryModalEl.addEventListener('shown.bs.modal', () => {
          this.getCategories();
          this.getCategoriesPaginated(this.categoryPage.current_page || 1);
        });
      }

      // Refrescar la tabla paginada cada vez que se abra el modal de colecciones
      const collectionModalEl = document.getElementById('ModalCollection');
      if (collectionModalEl) {
        collectionModalEl.addEventListener('shown.bs.modal', () => {
          this.getCollections();
          this.getCollectionsPaginated(this.collectionPage.current_page || 1);
        });
      }
    } else {
      console.log("No se encontró un usuario en el localStorage.");
      // Opcional: redirigir al login o mostrar un mensaje
    }
  }
};
</script>
